/**
 * RemindersPage — wrapper di backward compatibility
 * Il Diario di Bordo - Frontend
 *
 * La route `/promemoria` è stata consolidata dentro il Centro
 * Comunicazioni in `pages/NotificationsPage.jsx` (tab "promemoria").
 *
 * Questo wrapper redirect mantiene la backward compat per:
 *  - notifiche push reminder con actionUrl `/promemoria` o `/promemoria/<id>`
 *  - link salvati / bookmark utente
 */

import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export default function RemindersPage() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const isOrgRoute = location.pathname.startsWith('/organization')
    const base = isOrgRoute ? '/organization/notifiche' : '/notifiche'
    navigate(`${base}?tab=promemoria`, { replace: true })
  }, [location.pathname, navigate])

  return null
}
